export const atividadesConstants = {
  ACTIVITIES_SUCCESS: 'ACTIVITIES_SUCCESS',
  ACTIVITIES_REQUEST: 'ACTIVITIES_REQUEST',
  ACTIVITIES_ERROR: 'ACTIVITIES_ERROR',
};
